import { store } from "../store";

import { paymentApi } from "./apiSingleton";

export const PaymentAPI = paymentApi.injectEndpoints({
  endpoints: (builder) => ({
    createOpaquePayment: builder.query({
      query: ({ transactions, ...rest }) => {
        const { payment_api_path: payment_path } = store.getState().environment;

        return {
          url: payment_path,
          method: "POST",
          body: {
            transactions,
            ...rest,
          },
        };
      },
    }),
    createPaymentIntent: builder.query({
      query: ({ pnr, transactions, source }) => {
        const { sessionKey: session } = store.getState().session;

        return {
          url: "/initiate-payment/",
          method: "POST",
          body: {
            pnr,
            session,
            transactions,
            source,
          },
        };
      },
    }),
    createDirectPayment: builder.query({
      query: (body) => {
        return {
          url: "/make-payment/",
          method: "POST",
          body,
        };
      },
    }),
  }),
});

export const {
  useLazyCreateOpaquePaymentQuery,
  useLazyCreatePaymentIntentQuery,
  useLazyCreateDirectPaymentQuery,
} = PaymentAPI;
